import{n as e}from"../../../../_virtual/index13.js";var r,t;r=e,t=e.exports,Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(e,r,t,a,u,o,s){var l=new Date(0);return l.setUTCFullYear(e,r,t),l.setUTCHours(a,u,o,s),l},r.exports=t.default;
//# sourceMappingURL=index.js.map
